<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 16:06:51
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-01 11:11:54
 * @Description: 活码-销售二维码
 -->
<template>
  <div class="sale-qrcode">
    <!-- 搜索栏 -->
    <div class="search-line">
      <!-- 使用状态 -->
      <mk-select
        v-model="saleCodeStatus.value"
        class="select-common"
        :placeholder="saleCodeStatus.defaultText"
        width="200"
        clearable
        @change="checkoutStatus"
      >
        <mk-option
          v-for="item in saleCodeStatus.list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></mk-option>
      </mk-select>
      <!-- 名称搜索 -->
      <mk-input
        v-model="saleName"
        class="mr-16"
        width="240"
        placeholder="请输入销售名称"
        clearable
        @clear="searchSaleCode"
        @keyup.enter.native="searchSaleCode"
      >
        <div
          slot="suffix"
          class="el-input__icon"
        >
          <i
            class="el-icon-search"
            @click="searchSaleCode"
          />
        </div>
      </mk-input>
      <mk-button-biz
        type="primary"
        icon="el-icon-search"
        @click="searchSaleCode"
      >
        搜索
      </mk-button-biz>
      <mk-button-biz @click="reset">
        重置
      </mk-button-biz>
    </div>
    <!-- 企业活码表格 -->
    <div class="code-table">
      <mk-table
        v-if="tableMaxHeight"
        :max-height="tableMaxHeight"
        :data="tableData"
        style="width: 100%;"
      >
        <!-- 销售 -->
        <mk-table-column
          prop="name"
          label="销售"
        >
        </mk-table-column>
        <!-- 二维码缩略图 -->
        <mk-table-column
          prop="wx_qr_code_url"
          label="二维码缩略图"
        >
          <template v-slot="scope">
            <mk-popover
              placement="bottom"
              width="120"
              trigger="hover"
            >
              <img
                style="width:150px;"
                :src="scope.row.wx_qr_code_url"
                alt="销售二维码"
              />
              <mk-iconfont
                slot="reference"
                icon-class="erweima"
              />
            </mk-popover>
          </template>
        </mk-table-column>
        <!-- 活码使用状态 -->
        <mk-table-column
          prop="state"
          label="使用状态"
        >
          <template v-slot="scope">
            <span v-if="scope.row.enable_wx_qr_code">已启用</span>
            <span v-else>未启用</span>
          </template>
        </mk-table-column>
        <!-- 操作 -->
        <mk-table-column
          prop="handle"
          label="操作"
        >
          <template v-slot="scope">
            <!-- enable_wx_qr_code 当前销售二维码状态 启用/停用 -->
            <span
              v-if="!scope.row.enable_wx_qr_code"
              class="options-btn"
              @click="startUse(scope.row)"
            >
              启用
            </span>
            <span
              v-if="scope.row.enable_wx_qr_code"
              class="options-btn"
              @click="stopUse(scope.row)"
            >
              停用
            </span>
            <!-- 下载 -->
            <span
              class="options-btn"
              @click="downloadSaleQrcode(scope.row)"
            >
              下载
            </span>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <mk-pagination
        :current-page.sync="page"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SaleQrcode',
  components: {},
  props: {},
  data () {
    return {
      tableMaxHeight: 0,
      saleName: '',
      total: 0,
      page: 1,
      // 搜索参数
      searchParams: {},
      // 销售二维码 使用状态
      saleCodeStatus: {
        value: '',
        defaultText: '使用状态',
        list: [
          {
            value: true,
            label: '已启用'
          },
          {
            value: false,
            label: '未启用'
          }
        ]
      },
      // 销售二维码列表
      tableData: [],
      pageSize: 10
    }
  },
  watch: {},
  created () {
    this.getSaleCodeList()
  },

  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.code-table', this)
    })
  },
  methods: {
    // 获取销售二维码列表
    async getSaleCodeList (searchParams) {
      let params = {
        page: this.page,
        pageSize: this.pageSize,

        name: this.saleName,
        isEnable: this.saleCodeStatus.value,

        ...searchParams
      }

      if (!this.saleName) {
        delete params['name']
      }
      if (this.saleCodeStatus.value === '') {
        delete params['isEnable']
      }

      let res = await MKMATERIALSVC.QrCodeApi.qrcodeSaleListGet(params)
      if (res.success) {
        this.total = res.data.total
        this.tableData = res.data.data
      }
    },
    // 切换启用状态
    checkoutStatus () {
      this.searchSaleCode()
    },
    // 搜索
    searchSaleCode () {
      this.searchParams = {
        name: this.saleName,
        isEnable: this.saleCodeStatus.value
      }
      if (!this.saleName) {
        delete this.searchParams['name']
      }
      if (this.saleCodeStatus.value === '') {
        delete this.searchParams['isEnable']
      }
      this.getSaleCodeList(this.searchParams)
    },
    // 重置操作
    reset () {
      this.saleCodeStatus.value = ''
      this.saleName = ''
      this.page = 1
      this.getSaleCodeList()
    },
    // 分页
    handleCurrentChange (e) {
      this.page = e
      this.getSaleCodeList()
    },
    // 启用
    startUse (data) {
      // 停用状态变为启用
      // 接口参数 isEnable 传 true
      this.changeEnable(data, true)
    },
    // 停用
    stopUse (data) {
      // 启用状态变为停用
      // 接口参数 isEnable 传 fales
      this.changeEnable(data, false)
    },
    // 启用停用接口
    async changeEnable (data, isEnable) {
      let params = {
        userId: data._id,
        isEnable: isEnable
      }
      let res = await MKMATERIALSVC.QrCodeApi.qrcodeSwitchStatusGet(params)
      if (res.success) {
        if (isEnable) {
          this.$message.success('启用成功')
        } else {
          this.$message.success('停用成功')
        }
        this.searchSaleCode()
      }
    },
    // 下载销售二维码
    downloadSaleQrcode (data) {
      this.util.downloadImage({
        title: data.name,
        href: data.wx_qr_code_url
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
.sale-qrcode {
  display: flex;
  flex-direction: column;
  width: calc(100% - 32px);
  height: calc(100% - 20px);
  margin: 10px auto 0;

  & /deep/ .el-input__inner {
    padding-right: 50px;
  }

  & /deep/ .el-input__suffix {
    .el-input__clear {
      position: absolute;
      top: 0;
      left: -25px;
    }
  }

  a {
    text-decoration: none;
    color: #009cff;
  }

  .search-line {
    // display: flex;
    position: relative;

    .select-common {
      margin-right: 8px;
    }

    .mr-16 {
      margin-right: 16px;
    }
  }

  .code-table {
    margin-top: 10px;
    flex: 1;

    /deep/ .el-table__row {
      font-size: 13px;

      .el-button--text {
        font-size: 13px;
      }
    }

    .qrcode-img {
      width: 30px;
      height: 30px;
    }

    .options-btn {
      font-size: 13px;
      color: #009cff;
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .pagination {
    margin-bottom: 20px;
  }
}

// 删除
.salecode-delete-confirm {
  .mention-text {
    font-size: 14px;
    color: #595959;

    .icon-mk-jingshi {
      font-size: 14px;
      color: #faad14;
      margin-right: 8px;
    }
  }

  .button-delete-button {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
